/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CreateServiceProviderDto { 
    companyName?: string;
    accountEmail?: string;
    contactPersonFirstName?: string;
    contactPersonLastName?: string;
    contactPersonPhoneNumber?: string;
    status?: number;
    applicationId?: string;
    vasLicenseId?: string;
    vasLicenseActiveDate?: Date;
    vasLicenseExpiryDate?: Date;
    approved?: string;
    tenantId?: string;
    cacNumber?: string;
    roles?: Array<string>;
}